export default __webpack_public_path__ + "static/media/Cordell.dd0fafa7.jpg";